<template>
    <div class="page-content header-clear-medium">
			<div class="card card-style" style="margin: 0px 15px 30px 15px;">
			<div class="content">
				<div class="row">
					<div class="col-lg-3">
						<div class="form-custom form-border form-icon form-floating">
							<i class="bi bi-calendar font-12"></i>
							<input type="date" class="form-control rounded-xs" id="c5" v-model="presenceDate">
							<label for="c5" class="color-theme form-label-active">Pilih Tanggal</label>
							<div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
						</div>
					</div>
					<div class="col-lg-3 col-md-3 pe-0">
            <div class="form-custom form-label form-border form-icon mb-0">
                <i class="bi bi-list-ol font-13"></i>
                <select v-model="kelas_id" @change="onChangeFilterTingkat($event)" class="form-select rounded-xs" id="c7" aria-label="Floating label select example">
                    <option value="" selected="">- Pilih Tingkat -</option>
                    <option v-for="item in tingkats" :key="item.id" :value="item.id">{{ item.nama }}</option>
                </select>
                <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
            </div>
          </div>
					<div class="col-lg-3 col-md-3 pe-0">
            <div class="form-custom form-label form-border form-icon mb-0">
                <i class="bi bi-list-ol font-13"></i>
                <select v-model="rombel_id" @change="onChangeFilterRombel($event)" class="form-select rounded-xs" id="c7" aria-label="Floating label select example">
                    <option value="" selected="">- Pilih Kelas -</option>
                    <option v-for="item in rombels" :key="item.id" :value="item.id">{{ item.nama }}</option>
                </select>
                <div class="valid-feedback">HTML5 does not offer Dates Field Validation!<!-- text for field valid--></div>
            </div>
          </div>
					<div class="col-lg-3">
						<button class="btn bg-green-light w-100" @click="getDetailPresenceByDate">Cari</button>
					</div>
				</div>
			</div>
		</div>
		<div class="card card-style">
			<div class="content mb-0" v-if="!loading">
				<div v-if="presences_detail.length > 0">
					<div v-for="(item, index) in presences_detail" :key="index">
						<div class="d-flex justify-content-between">
							<div class="">
								<h5 class="mb-1">{{ item.name }} <span class="badge bg-highlight color-white ms-1">{{ item.homeroom }}</span></h5>
							</div>
							<button class="btn-xxs btn border-green-dark color-green-dark me-1" @click="sendWhatsappReportTrigger(item)">Whatsapp</button>
						</div>
						<ul class="ps-3">
							<li><mark class="highlight ps-2 font-12 pe-2 bg-primary text-white">Hadir</mark> : <span class="font-700 mb-0">{{ item.details['H'] }} Siswa</span></li>
							<li><mark class="highlight ps-2 font-12 pe-2 bg-yellow-dark">Sakit</mark> : <span class="font-700 mb-0">{{ item.details['S'] }} Siswa</span></li>
							<li><mark class="highlight ps-2 font-12 pe-2 bg-green-dark">Izin</mark> : <span class="font-700 mb-0">{{ item.details['I'] }} Siswa</span></li>
							<li><mark class="highlight ps-2 font-12 pe-2 bg-red-dark">Alfa</mark> : <span class="font-700 mb-0">{{ item.details['A'] }} Siswa</span></li>
							<li><mark class="highlight ps-2 font-12 pe-2 bg-gray-dark">Belum Ada Keterangan</mark> : <span class="font-700 mb-0">{{ item.details['others'] }} Siswa</span></li>
						</ul>
						<div class="divider"></div>
					</div>
				</div>
				<div v-else>
					<div class="alert alert-warning">
						Data Tidak Ditemukan!
					</div>
				</div>
			</div>
			<div class="content" v-else>
					<div v-for="i in 10" :key="i">
						<vue-skeleton-loader
							:height="100"
							animation="fade" 
							class="w-100 rounded-s mt-3"
						/>
					</div>
			</div>
		</div>
    </div>
</template>

<script>
import { 
	mapActions, mapState, mapMutations
} from 'vuex'
import moment from 'moment'

export default {
    name: 'Presence',
    components: {
    },
    data() {
			return {
				presenceDate: moment(this.$route.query.date).format('YYYY-MM-DD') ?? moment().format('YYYY-MM-DD'),
				kelas_id: "",
				rombel_id: "",
			}
    },
    async created() {
			// this.getDetailPresenceByDate()
			this.SET_LOADING()
			await this.getTingkat()
			await this.getRombel()
			this.CLEAR_LOADING()
    },
    methods: {
			...mapMutations(['SET_LOADING', 'CLEAR_LOADING']),
      ...mapActions('presence', ['getPresencesDetail', 'sendWhatsappReport']),
			...mapActions('data', ['getTingkat', 'getRombel']),
			async getDetailPresenceByDate() {
				this.SET_LOADING()

				await this.getPresencesDetail({
					date: this.presenceDate,
					kelas_id: this.kelas_id,
					rombel_id: this.rombel_id,
				})

				this.CLEAR_LOADING()
			},
			sendWhatsappReportTrigger(item) {
				const message = `Yth. ${item.homeroom} detail presensi kelas ${item.name} adalah sebagai berikut: %0a%0aHadir: ${item.details['H']}%0aSakit: ${item.details['S']}%0aIzin: ${item.details['I']}%0aAlfa: ${item.details['A']}%0aBelum ada keterangan: ${item.details['others']}%0a`;
				let phone = item.homeroom_phone;

				if(phone.length == 0) {
					alert("Walikelas tidak memiliki nomor!");
					return;
				}

				if(phone[0] == "0"){
					phone = phone.substring(0, 0) + "62" + phone.substring(0 + "62".length)
				}

				window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
			},
			async onChangeFilterTingkat(event) {
				if(this.kelas_id != ""){
					await this.getRombel(this.kelas_id);
				}
			},
			async onChangeFilterRombel(event) {
			}
    },
    computed: {
			...mapState({
				loading: state => state.loading
			}),
			...mapState('presence', {
					presences_detail: state => state.presences_detail
			}),
			...mapState('data', {
            tingkats: state => state.tingkats,
            rombels: state => state.rombels,
        }),
    }
}
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }
</style>
